/**
 * src/lib/nav/contactNav.js — directory contact deep-link request.
 *
 * Race-free "open contact C in the Directory" request — the directory mirror of
 * dealNav/projectNav. A global-search contact/person result (or a future
 * `/contact/<id>` link) sets this + switches to the Directory tab; DirectoryView
 * consumes it on mount / on a contacts-loaded retry and opens the contact detail
 * sheet directly, so the user lands on the detail instead of the list (CEO
 * 2026-06-21: search must reach the entity detail in one click). peek/consume
 * keeps it idempotent — cleared only once the contact is found + opened.
 */

let pending = null;
const listeners = new Set();

/** Request that DirectoryView open `contactId` (user_profiles.id or vessel_contacts.id). */
export function requestContactOpen(contactId) {
  if (!contactId) return;
  pending = { contactId };
  listeners.forEach((l) => {
    try { l(); } catch { /* spine-emit-ok: a listener error must not break navigation */ }
  });
}

/** Read the pending request without clearing it (so a failed open can retry). */
export function peekContactOpen() { return pending; }

/** Read + clear the pending request (call only once you've handled it). */
export function consumeContactOpen() { const p = pending; pending = null; return p; }

/** Subscribe to new requests; returns an unsubscribe fn. */
export function subscribeContactOpen(cb) { listeners.add(cb); return () => listeners.delete(cb); }

/** Test helper. */
export function _resetContactNav() { pending = null; listeners.clear(); }
